import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HomepagePropsProvider } from './components/stack/hooks/content/useHomepageProps';
import { Home } from './components/stack/views/Home/Home';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();
  const root = createRoot(container);

  root.render(
    <BaseContentProvider>
      <HomepagePropsProvider>
        <DefaultLayout>
          <Home />
        </DefaultLayout>
      </HomepagePropsProvider>
    </BaseContentProvider>
  );
});
